import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAsset } from "../../actions/assetAction";
import { useNavigate } from "react-router";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import {
  getSecurityType,
  getInvestmentStatus,
  getAssetClass,
  getFundStatus,
  getPrimaryAnalyst,
  getSecondaryAnalyst,
  getStrategy,
  getSubStrategy,
  getRegion,
  getSubRegion,
  getSector,
  getSubSector,
} from "../../actions/assetDetailsActions";
import { getManagerContacts } from "../../actions/CommonAction";
import { BreadCrumbs } from "../../shared/breadCrumbs/BreadCrumbs";
import { useParams, useLocation } from "react-router-dom";
import { LoadingScreen } from "../../UiComponents/LoadingComponent";
import { SBAComboBox, SBADropDown } from "../../UiComponents/SBADropDown";
import { UrlPath } from "../../../config/routeConfig";
import moment from "moment";
import { TopBar } from "../../shared/topBar/TopBar";
import { ToastContainer, toast } from 'react-toastify';
import "./AssetEdit.css";
import { InsertorUpdateAsset, insertAssetManager } from "../../../config/apiConfig";
import { SBATextBox } from "../../UiComponents/SBATextBox";
import { sbaAxios } from "../../utils/sbaAxios";
import { SBDatePicker } from "../../UiComponents/SBDatePicker";
import { Modal } from "react-bootstrap";
export const AssetEdit = () => {

  const Gstate=useSelector(state=>state) || {};
  const isEditable =Gstate.authorizationData.isEditable;
  
  const params = useParams();
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const locationData = useLocation();



  const currentAsset = useSelector((state) => state.asset.asset);
  const securityType = Gstate.assetSecurityType.assetSecurityType;
  const investmentStatus = Gstate.assetInvestStatus.assetInvestStatus;
  const assetclass = Gstate.assetClass.assetClass;
  const fundstatus = Gstate.fundStatus.fundStatus;
  const primaryanalyst = Gstate.primaryAnalyst.primaryAnalyst;
  const secondaryanalyst = Gstate.secondaryAnalyst.secondaryAnalyst;
  const Strategy = Gstate.strategy.strategy;
  const SubStrategy = Gstate.subStrategy.subStrategy;
  const Region = Gstate.region.region;
  const SubRegion = Gstate.subregion.subregion;
  const Sector = Gstate.sector.sector;
  const Subsector = Gstate.subsector.subsector;
  const manager = Gstate.managerContacts.managerContacts;
   
  const [selectedSecurityType, setSelectedSecurityType] = useState({ AssetTypeId: currentAsset?.SecurityTypeId, AssetTypeName: currentAsset?.SecurityType });

  const [selectedAssetClass, setSelectedAssetClass] = useState({ ClassificationId: currentAsset?.AssetClassId, ClassificationValue: currentAsset?.AssetClass });

  const [selectedStrategy, setSelectedStrategy] = useState({ ClassificationId: currentAsset?.StrategyId, ClassificationValue: currentAsset?.Strategy });

  const [selectedSubStrategy, setSelectedSubStrategy] = useState({ ClassificationId: currentAsset?.SubstrategyId, ClassificationValue: currentAsset?.Substrategy });

  const [selectedRegion, setSelectedRegion] = useState({ ClassificationId: currentAsset?.RegionId, ClassificationValue: currentAsset?.Region });

  const [selectedInvestmentStatus, setSelectedInvestmentStatus] = useState({ EnumValue: currentAsset?.InvestmentStatusId, EnumName: currentAsset?.InvestmentStatus });

  const [selectedSubRegion, setSelectedSubRegion] = useState({ ClassificationId: currentAsset?.SubregionId, ClassificationValue: currentAsset?.Subregion});

  const [selectedAssetStatus, setSelectedAssetStatus] = useState({ AssetStatusId: currentAsset?.AssetStatusId, AssetStatus: currentAsset?.AssetStatus });

  const [selectedSector, setSelectedSector] = useState({ ClassificationId: currentAsset?.SectorId, ClassificationValue: currentAsset?.Sector });

  const [selectedPrimaryAnalyst, setSelectedPrimaryAnalyst] = useState({ UserId: currentAsset?.PrimaryAnalystId, AnalystName: currentAsset?.PrimaryAnalyst });

  const [selectedSubSector, setSelectedSubSector] = useState({ ClassificationId: currentAsset?.SubSectorId, ClassificationValue: currentAsset?.SubSector });

  const [selectedSecondaryAnalyst, setSelectedSecondaryAnalyst] = useState({ UserId: currentAsset?.SecondaryAnalystId, AnalystName: currentAsset?.SecondaryAnalyst });

    const [selectedAssetName, setSelectedAssetName] = useState('');
    const [newManager, setnewManager] = useState([]);
    const [newManagerID, setnewManagerID] = useState({ ManagerContactId: 0, ManagerContact: ""});

    const [selectedAbbreviationName, setSelectedAbbreviationName] = useState('');
    const [showModal, setShowModal] = useState(false);
  //const [selectedEffectiveDate, setSelectedEffectiveDate] = useState(new Date());
    const [selectedEffectiveDate, setSelectedEffectiveDate] = useState(
        currentAsset.EffectiveDate
            ? moment(currentAsset.EffectiveDate).toDate()
            : null
    );
    const [selectedStrategyDescription, setSelectedStrategyDescription] = useState('');
    const [selectedManager, setSelectedManager] = useState([]);
    const [resulttrim, setResulttrim] = useState();
    const [managertrim, setmanagertrim] = useState();
    const [trimAberivation, settrimAberivation] = useState();
  useEffect(() => {
    dispatch(getAsset(params.Asset));
    dispatch(getSecurityType());
    dispatch(getInvestmentStatus(1));
    dispatch(getAssetClass());
    dispatch(getFundStatus());
    dispatch(getPrimaryAnalyst());
    dispatch(getSecondaryAnalyst());
    dispatch(getStrategy());
    dispatch(getSubStrategy());
    dispatch(getRegion());
    dispatch(getSubRegion());
    dispatch(getSector());
      dispatch(getSubSector());
     dispatch(getManagerContacts());
      
  }, []);
  const history = useNavigate();
  const Level = [
    { BreadCrumb: "Asset >", Routes: `${UrlPath.Asset}` },
    { BreadCrumb: "Details >", Routes: `${UrlPath.AssetDetails}${params.Asset}` },
    { BreadCrumb: "Edit", Routes: `${UrlPath.AssetEdit}${params.Asset}` },
  ];

 //cancel Button
  const CancelButtonClick = () => {
    if(previousPage=="AssetDetails")
    history(`${UrlPath.AssetDetails}${params.Asset}`, { state: { ActiveTab: currentTab, ActiveTabID: currentTabID } });
    else
    history(`${UrlPath.Asset}`);
    };

  const previouslyActiveTab = locationData.state === null ? "Details" : locationData.state.ActiveTabID === 1 ? "Details" : locationData.state.ActiveTabID === 2 ? "Attributes" : locationData.state.ActiveTabID === 3 ? "shareClass" : "Details";
  let currentTabID = locationData.state?.ActiveTabID && 1;
  let currentTab = previouslyActiveTab;
  const previousPage=locationData.state?.CurrentPage;
  
  useEffect(() => {
    document.title = "Asset Edit";
  }, []);

    useEffect(() => {
    if (currentAsset?.AssetId == params.Asset) {
      setLoading(false);
    }

    setSelectedAssetName(currentAsset?.AssetName);
    
    setSelectedAbbreviationName(currentAsset?.AbbrName);

    setSelectedEffectiveDate(currentAsset.EffectiveDate && (moment(currentAsset.EffectiveDate).format('MM/DD/YYYY')));

    setSelectedSecurityType({ AssetTypeId: currentAsset?.SecurityTypeId, AssetTypeName: currentAsset?.SecurityType });

    setSelectedAssetClass({ ClassificationId: currentAsset?.AssetClassId, ClassificationValue: currentAsset?.AssetClass });

    setSelectedStrategy({ ClassificationId: currentAsset?.StrategyId, ClassificationValue: currentAsset?.Strategy });

    setSelectedSubStrategy({ ClassificationId: currentAsset?.SubstrategyId, ClassificationValue: currentAsset?.Substrategy });

    setSelectedRegion({ ClassificationId: currentAsset?.RegionId, ClassificationValue: currentAsset?.Region });

    setSelectedInvestmentStatus({ EnumValue: currentAsset?.InvestmentStatusId, EnumName: currentAsset?.InvestmentStatus });

     setSelectedSubRegion({ ClassificationId: currentAsset?.SubregionId, ClassificationValue: currentAsset?.Subregion });

    setSelectedAssetStatus({ AssetStatusId: currentAsset?.AssetStatusId, AssetStatus: currentAsset?.AssetStatus });

    setSelectedSector({ ClassificationId: currentAsset?.SectorId, ClassificationValue: currentAsset?.Sector });

    setSelectedPrimaryAnalyst({ UserId: currentAsset?.PrimaryAnalystId, AnalystName: currentAsset?.PrimaryAnalyst });

    setSelectedSubSector({ ClassificationId: currentAsset?.SubSectorId, ClassificationValue: currentAsset?.SubSector });
      setSelectedSecondaryAnalyst({ UserId: currentAsset?.SecondaryAnalystId, AnalystName: currentAsset?.SecondaryAnalyst });
      setSelectedStrategyDescription(currentAsset.StrategyDescription)
    }, [Gstate]);
    useEffect(() => {
        if (newManagerID.ManagerContactId !== 0) {
            setSelectedManager({
                ManagerContactId: newManagerID.ManagerContactId,
                ManagerContact: newManagerID.ManagerContact
            });
        } else {
            setSelectedManager({
                ManagerContactId: currentAsset?.ManagerContactId,
                ManagerContact: currentAsset?.ManagerContact
            });
        }

      
    }, [newManagerID,currentAsset]);
    const securityDropdownChange = (e) => {
        if (e.value)
    setSelectedSecurityType(e.value);
    };
    const managerDropdownChange = (e) => {
        if (e.value)
        setSelectedManager(e.value);
    };
    const assetclassDropdownChange = (e) => {
        if (e.value)
    setSelectedAssetClass(e.value);
  };
    const strategyDropdownChange = (e) => {
        if (e.value)
    setSelectedStrategy(e.value);
  };
  const subStrategyDropdownChange = (e) => {
    if(e.value)
    setSelectedSubStrategy(e.value);
  };
    const regionDropdownChange = (e) => {
        if (e.value)
    setSelectedRegion(e.value);
  };
    const investmentStatusDropdownChange = (e) => {
        if (e.value)
    setSelectedInvestmentStatus(e.value);
  };
  const subRegionDropdownChange = (e) => {
    setSelectedSubRegion(e.value);
    };
    const assetStatusDropdownChange = (e) => {
        if (e.value)
    setSelectedAssetStatus(e.value);
  };
    const sectorDropdownChange = (e) => {
        if (e.value)
    setSelectedSector(e.value);
  };
    const primaryAnalystDropdownChange = (e) => {
        if (e.value)
    setSelectedPrimaryAnalyst(e.value);
  };
    const subsectorDropdownChange = (e) => {
        if (e.value)
    setSelectedSubSector(e.value);
  };
    const secondaryAnalystDropdownChange = (e) => {
        if (e.value)
    setSelectedSecondaryAnalyst(e.value);
  };
    const assetNameChange = (event) => {
        const result = SBATextBox(event.target.value)
        setResulttrim(result);
    setSelectedAssetName(event.target.value);
    };


    const AddnewnmanagerChange = (event) => {
        const result = SBATextBox(event.target.value)
        setmanagertrim(result);
        setnewManager(event.target.value)
       // setSelectedManager(event.target.value);
    };

    const abbreviationChange = (event) => {
        const result = SBATextBox(event.target.value)
        settrimAberivation(result);
    setSelectedAbbreviationName(event.target.value);
  };
  const effectiveDateChange = (newDate) => {
     // setSelectedEffectiveDate(new Date(moment(selected.value).format('MM/DD/YYYY')));
      setSelectedEffectiveDate(newDate);
  };

  const StrategyDescChange = (event) => {
    setSelectedStrategyDescription(event.target.value);

    };
    const UpdateAssetDetails = (event) => {   
    event.preventDefault();
    let saveSuccess = true;
    let errorMsg = [];
    // Prepare the data to be sent in the POST request
    const data = {
      "assetId": params.Asset,
      "securityTypeId": selectedSecurityType.AssetTypeId,
      "securityType": selectedSecurityType.AssetTypeName,
      "assetClassId": selectedAssetClass.ClassificationId,
      "assetClass": selectedAssetClass.ClassificationValue,
      "strategyId": selectedStrategy.ClassificationId,
      "strategy": selectedStrategy.ClassificationValue,
      "substrategyId": selectedSubStrategy.ClassificationId,
      "substrategy": selectedSubStrategy.ClassificationValue,
      "regionId": selectedRegion.ClassificationId,
      "region": selectedRegion.ClassificationValue,
      "investmentStatusId": selectedInvestmentStatus.EnumValue,
      "investmentStatus": selectedInvestmentStatus.EnumName,
      "subregionId": selectedSubRegion.ClassificationId,
      "subregion": selectedSubRegion.ClassificationValue,
      "assetStatusId": selectedAssetStatus.AssetStatusId,
      "assetStatus": selectedAssetStatus.AssetStatus,
      "sectorId": selectedSector.ClassificationId,
      "sector": selectedSector.ClassificationValue,
      "primaryAnalystId": selectedPrimaryAnalyst.UserId,
      "primaryAnalyst": selectedPrimaryAnalyst.AnalystName,
      "subSectorId": selectedSubSector.ClassificationId,
      "subSector": selectedSubSector.ClassificationValue,
      "secondaryAnalystId": selectedSecondaryAnalyst.UserId,
      "secondaryAnalyst": selectedSecondaryAnalyst.AnalystName,
      "assetName": selectedAssetName,
      "abbrName": selectedAbbreviationName,
      "effectiveDate": selectedEffectiveDate,
      "StrategyDescription": selectedStrategyDescription,
      "managerContactId": selectedManager
    };

    const newdata={
      "assetId": params.Asset,
      "securityTypeId": selectedSecurityType.AssetTypeId,
      "securityType": selectedSecurityType.AssetTypeName,
      "assetClassId": selectedAssetClass.ClassificationId,
      "assetClass": selectedAssetClass.ClassificationValue,
      "assetName": selectedAssetName,
      "strategyId": selectedStrategy.ClassificationId,
      "strategy": selectedStrategy.ClassificationValue,
      "substrategyId": selectedSubStrategy.ClassificationId,
      "substrategy": selectedSubStrategy.ClassificationValue,
      "strategyDescription": selectedStrategyDescription,
      "abbrName": selectedAbbreviationName,
      "effectiveDate": selectedEffectiveDate,
      "overrideStrategy": "string",  //doubt
      "investmentStatusId": selectedInvestmentStatus.EnumValue,
      "investmentStatus": selectedInvestmentStatus.EnumValue,
      "regionId": selectedRegion.ClassificationId,
      "region": selectedRegion.ClassificationValue,
      "subregionId": selectedSubRegion.ClassificationId,
      "subregion": selectedSubRegion.ClassificationValue,
      "assetStatusId": selectedAssetStatus.AssetStatusId,
      "assetStatus": selectedAssetStatus.AssetStatus,
      "primaryAnalystId": selectedPrimaryAnalyst.UserId,
      "primaryAnalyst": selectedPrimaryAnalyst.AnalystName,
      "secondaryAnalystId": selectedSecondaryAnalyst.UserId,
      "secondaryAnalyst": selectedSecondaryAnalyst.AnalystName,
      "sectorId": selectedSector.ClassificationId,
      "sector": selectedSector.ClassificationValue,
      "subSectorId": selectedSubSector.ClassificationId,
      "subSector": selectedSubRegion.ClassificationValue,
      "managerContactId":selectedManager.ManagerContactId,
      "accountTypeId": 0,
      "primaryBM": "string",
      "secondaryBM": "string",
      "modifiedBy": 32,
      "returnsList": [
        {
          "dateType": "string",
          "returnAmount": 0,
          "returnDate": "2023-07-19T12:25:30.153Z",
          "returnFreq": 1,
          "isFinal": true,
          "roR": 0,
          "roRNullable": 0
        }
      ],
      "assetsList": [
        {
          "assetType": "string",
          "assetValue": 0,
          "assetId": 0,
          "assetName": "string",
          "accountTypeId": 0
        }
      ],
      "portfolioHoldings": [
        {
          "familyName": "string",
          "basketId": 0,
          "basketName": "string",
          "investmentValue": 0
        }
      ],
      "transactionList": [
        {
          "transTypeId": 0,
          "transName": "string",
          "transDate": "2023-07-19T12:25:30.153Z",
          "transValue": 0
        }
      ]
    }
        if ((resulttrim == false)||(selectedAssetName.length === 0)) {
      saveSuccess = false;
      errorMsg.push("Please Enter Asset Name");
    }
        else if((trimAberivation == false)||(selectedAbbreviationName.length === 0)) {
      saveSuccess = false;
      errorMsg.push("Please Enter Abbreviation Name");
    }
    else if (!selectedSecurityType.AssetTypeId) {
      saveSuccess = false;
      errorMsg.push("Please select Security Type");
    }
    else if (!selectedStrategy.ClassificationId) {
      saveSuccess = false;
      errorMsg.push("Please select Strategy");
    }
        if (saveSuccess) {
            sbaAxios({
                url: `${InsertorUpdateAsset}`,
                method: 'post',
                data: newdata,
            })
                .then((response) => {
              if (response > 0) {
                  toast.success('Asset Updated Successfully', {
                      position: "top-right",
                      autoClose: 5000,
                      hideProgressBar: false,
                      closeOnClick: true,
                      pauseOnHover: true,
                      draggable: true,
                      progress: undefined,
                      theme: "light",
                  })
                  setTimeout(() => {
                      history(`${UrlPath.AssetDetails}${params.Asset}`);
                  }, 1000);
              }
              else if (response = -999) {
                  toast.error('Asset name  Already Exists', {
                      position: "top-right",
                      autoClose: 5000,
                      hideProgressBar: false,
                      closeOnClick: true,
                      pauseOnHover: false,
                      draggable: true,
                      progress: undefined,
                      theme: "light",
                  })
              }
          
        })

          .catch((error) => {
          console.error(error);
        });
    }
    else {
      let ErrorString = "";
      errorMsg.map(item => { ErrorString = `${ErrorString}${item} \n` });
      console.log(errorMsg);
      toast.error(ErrorString, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
      })
    }

    };
    const AddManagername = () => {     
        let saveSuccess = true;
        let errorMsg = [];     
        if ((managertrim == false) || (newManager.length === 0)) {
            saveSuccess = false;
            errorMsg.push("Please Enter Manager Name");
        }
        
        if (saveSuccess) {
            sbaAxios({
                url: `${insertAssetManager}${newManager}`,
                method: 'get'
            })
                .then((response) => {
                    if (response > 0) {
                        toast.success('Manager Name Added Successfully', {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                        })                       
                         dispatch(getManagerContacts());
                         setSelectedManager({ ManagerContactId: response, ManagerContact: newManager });                                                           
                        setnewManagerID({ ManagerContactId: response, ManagerContact: newManager });
                        setShowModal(false);
                    }
                    else if (response ===-1) {
                        toast.error('Manager name  Already Exists', {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: false,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                        })
                    }

                })

                .catch((error) => {
                    console.error(error);
                });
        }
        else {
            let ErrorString = "";
            errorMsg.map(item => { ErrorString = `${ErrorString}${item} \n` });
            console.log(errorMsg);
            toast.error(ErrorString, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "light",
            })
        }

    };



    const closeModal = () => {
       
        setShowModal(false);
    };

    const ManagerAddclk = () => {

        setShowModal(true);
        setnewManager([]);

    }
  const GetCurrentTab = (e) => {
    if (e === "Details") {
      currentTabID = 1;
      currentTab = e;
    }
    if (e === "Attributes") {
      currentTabID = 2;
      currentTab = e;
    }
    if (e === "shareClass") {
      currentTabID = 3;
      currentTab = e;
    }
  };
  return (
    <div>
      {loading ? (
        <LoadingScreen />
      ) : (
        <>
          <TopBar label={"Asset Edit"} />
          <BreadCrumbs Levels={Level} />
          <div id="content" class="asset-detail-screen mainContentData">
            <div class="p-4">
              <div class="d-flex align-items-center justify-content-between my-2 flex-wrap flex-lg-nowrap">
                <div class="d-flex gap-2 align-items-center">
                  <h2 class="fw-medium fs-6 m-0">{currentAsset?.AssetName}</h2>
                </div>
                <div>
                </div>
              </div>
                <div id="manfield" className="p-3 life-science rounded">
                  <div className="row ">
                    <div className="col-md-4">
                      <div className="my-4">
                        <label className="label">Asset Name<span className="mandatory">*</span></label>
                        <input
                                className="form-control w-75"
                                type="text"
                                Value={
                                  currentAsset.AssetName
                                    ? currentAsset.AssetName
                                    : ""
                                }
                                onChange={assetNameChange}
                                required
                              />
                      </div>
                      <div className="my-1">
                        <label className="label">Abbreviation Name<span className="mandatory">*</span></label>
                        <input
                                className="form-control w-75"
                                type="text"
                                Value={currentAsset.AbbrName
                                  ? currentAsset.AbbrName
                                  : ""}
                                onChange={abbreviationChange}
                                required
                              />
                      </div>
                      <div  className="my-4">
                        <label className="label">Asset Manager</label>
                        <div className="d-flex gap-2">
                                                  <SBAComboBox
                                                  className="w-75"
                                                  data={manager}
                                                  value={selectedManager}
                                                  textField={"ManagerContact"}
                                                  valueField={"ManagerContactId"}
                                                  onChange={managerDropdownChange}
                                                  />
                                                 <div  className="d-flex mt-2 gap-3">
                                            {/* <i className="fa-solid fa-add SBA_icon" onClick={ManagerAddclk} /> */}
                                            </div>   
                                            </div>
                                              
                      </div>
                      <div className="my-4">
                        <label className="label">Security Type<span className="mandatory">*</span></label>
                        <div>
                            <SBAComboBox
                                className="w-75"
                                data={securityType}
                                value={selectedSecurityType}
                                textField={"AssetTypeName"}
                                valueField={"AssetTypeId"}
                                onChange={securityDropdownChange}
                              />
                        </div>
                        
                      </div>
                      <div className="my-4">
                        <label className="label">Inception Date	</label>
                        <div>
                                                  <SBDatePicker
                                                      className="w-75"
                                                      defaultValue={
                                                          currentAsset.EffectiveDate
                                                              ? moment(currentAsset.EffectiveDate)
                                                              : null
                                                      }
                                                      onChange={effectiveDateChange}
                                                      style={{
                                                          borderColor:
                                                              selectedEffectiveDate || currentAsset.EffectiveDate ? '' : 'transparent',
                                                      }}
                                                  />

                        </div>
                      </div>
                      <div className="my-4">
                        <label className="label">Investment Status</label>
                        <div>
                       <SBAComboBox
                            className='w-75'
                            value={
                              selectedInvestmentStatus
                            }
                            textField={"EnumName"}
                            valueField={"EnumValue"}
                            data={investmentStatus}
                            onChange={investmentStatusDropdownChange}
                          />
                        </div>
                      </div>
                      <div className="my-4" >
                        <label className="label">Asset Status	</label>
                        <div>
                     <SBAComboBox
                        className='w-75'
                                value={
                                  selectedAssetStatus
                                }
                                textField={"AssetStatus"}
                                valueField={"AssetStatusId"}
                                data={fundstatus}

                                onChange={assetStatusDropdownChange}
                              />
                        </div>
                      </div>
                      <div className="my-4" >
                        <label className="label">Primary Analyst</label>
                        <div>
                          <SBAComboBox
                          className="w-75"
                            value={
                              selectedPrimaryAnalyst
                            }
                            textField={"AnalystName"}
                            valueField={"UserId"}
                            data={primaryanalyst}
                            onChange={primaryAnalystDropdownChange}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="my-4">
                        <label className="label">Secondary Analyst</label>
                        <div>
                           <SBAComboBox
                                value={
                                  selectedSecondaryAnalyst
                                }
                                className="w-75"
                                textField={"AnalystName"}
                                valueField={"UserId"}
                                data={secondaryanalyst}

                               onChange={secondaryAnalystDropdownChange}
                              />
                        </div>
                      </div>
                      <div className="my-4">
                        <label className="label">Asset Class</label>
                        <div>
                      <SBAComboBox
                        className="w-75"
                                value={
                                  selectedAssetClass
                                }
                                textField={"ClassificationValue"}
                                valueField={"ClassificationId"}
                                data={assetclass}
                                onChange={assetclassDropdownChange}
                              />
                        </div>
                      </div>
                      <div className="my-4">
                        <label className="label">Strategy <span className="mandatory">*</span></label>
                        <div>
                          <SBAComboBox
                                className='w-75'
                                value={
                                  selectedStrategy
                                }
                                textField={"ClassificationValue"}
                                valueField={"ClassificationId"}
                                data={Strategy}

                                onChange={strategyDropdownChange}
                              />
                        </div>
                      </div>
                      <div className="my-4">
                        <label className="label">Sub Strategy	</label>
                        <div>
                        <SBAComboBox
                        className="w-75"
                                value=
                                {
                                  selectedSubStrategy
                                }
                                textField={"ClassificationValue"}
                                valueField={"ClassificationId"}
                                data={SubStrategy}
                                onChange={subStrategyDropdownChange}
                              />
                        </div>
                        
                      </div>
                      <div className="my-4">
                        <label className="label">Sector</label>
                        <div>
                       <SBAComboBox
                        className="w-75"
                                value={
                                  selectedSector
                                }
                                textField={"ClassificationValue"}
                                valueField={"ClassificationId"}
                                data={Sector}
                                autosize={false}
                                onChange={sectorDropdownChange}
                              />
                        </div>
                      </div>
                      <div className="my-4">
                        <label className="label">Sub Sector	</label>
                        <div>
                       <SBAComboBox
                        className="w-75"
                              value={
                                selectedSubSector
                              }
                              textField={"ClassificationValue"}
                              valueField={"ClassificationId"}
                              data={Subsector}

                              onChange={subsectorDropdownChange}
                            />
                        </div>
                      </div>
                      <div className="my-4">
                        <label className="label">Region</label>
                        <div>
                      <SBAComboBox
                        className="w-75"
                                value={
                                  selectedRegion
                                }
                                textField={"ClassificationValue"}
                                valueField={"ClassificationId"}
                                data={Region}

                                onChange={regionDropdownChange}
                              />
                        </div>
                      </div>
                      <div className="my-4">
                        <label className="label">Classification</label>
                        <div>
                       <SBAComboBox
                        className="w-75"
                                value={
                                  selectedSubRegion
                                }
                                textField={"ClassificationValue"}
                                valueField={"ClassificationId"}
                                data={SubRegion}

                                onChange={subRegionDropdownChange}
                              />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                    <span style={{ marginLeft: "2%", fontWeight: "bold" }}>Strategy Description</span>
                      <textarea style={{ marginLeft: "2%" }} id="txtStrategydesc" className="form-control" rows={7} defaultValue={
                        currentAsset.StrategyDescription
                                                  ? currentAsset.StrategyDescription
                                                  : ""   
                      } onChange={StrategyDescChange} ></textarea>
                    </div>
                </div>
              </div>
              <div className="col-lg-12 d-flex gap-2 justify-content-lg-end align-items-center mt-4">
                <button className="s-sm-btn mx-1" onClick={CancelButtonClick}> Cancel</button>
                <button className='p-sm-btn mx-1' onClick={UpdateAssetDetails} disabled={!isEditable}>Update</button>
              </div>
                          </div>


                          {<Modal show={showModal}  >
                              <Modal.Header closeButton onClick={closeModal}>
                                  <Modal.Title>Add New Manager</Modal.Title>
                              </Modal.Header>
                              <Modal.Body>
                                  <div>
                                  <label className="header-container m-1">
                                      <b>Manager Name</b>
                                  </label>
                                  <div>
                                      <input
                                          className="form-control w-75"
                                          type="text"
                                          value={newManager}
                                         onChange={AddnewnmanagerChange}
                                         popupSettings={{ style: "z-index:1051", className: "modalDD" }}
                                          
                                      />
                                  </div>
                                  <br></br>
                                  </div>
                              </Modal.Body>
                              <Modal.Footer>
                                  <button className="s-sm-btn mx-1" onClick={closeModal} > Cancel</button>
                                  <button className='p-sm-btn mx-1' onClick={AddManagername} >
                                      Save
                                </button>
                              </Modal.Footer>
                          </Modal>}

          </div>
          <ToastContainer></ToastContainer>
        </>

      )}

    </div>

  );
};
